import { getContract, PublicClient, WalletClient } from 'viem';

import mainTokenAbi from 'modules/api/abi/MainToken';
import { MAIN_TOKEN_ADDRESS } from 'modules/api/const';

export function getMainTokenContract(client: WalletClient | PublicClient) {
  return getContract({
    address: MAIN_TOKEN_ADDRESS,
    abi: mainTokenAbi,
    client,
  });
}
